import { downloadConstants } from 'store/constants';
import { EachWorkdeskTicketI } from 'store/models/workdesk-tickets/each-workdesk-ticket.interface';
import { LoadWorkdeskTicketsParams } from 'store/models/workdesk-tickets/workdesk-tickets.interface';

const initialState = {
  isLoading: false,
  params: null as LoadWorkdeskTicketsParams | null,
  tickets: [] as EachWorkdeskTicketI[], // TODO: check type
};

export const forDownload = (
  state = initialState,
  action: {
    type: string;
    payload?: {
      tickets?: EachWorkdeskTicketI[];
      params?: LoadWorkdeskTicketsParams;
      error?: string;
    };
  },
) => {
  switch (action.type) {
    case downloadConstants.LOAD_CSV_TICKETS_REQUEST:
      return {
        ...state,
        isLoading: true,
        params: action.payload?.params, // set params
        tickets: [],
      };
    case downloadConstants.LOAD_CSV_TICKETS_SUCCESS:
      if (!action.payload?.tickets)
        throw Error(`payload.tickets is missing`);
      return {
        ...state,
        isLoading: false,
        params: null, // reset params
        tickets: action.payload?.tickets,
      };
    case downloadConstants.LOAD_CSV_TICKETS_ERROR:
      return {
        ...state,
        isLoading: false,
        params: null, // reset params
        error: action.payload?.error,
        tickets: [],
      };
    default:
      return state;
  }
};
